// Cette enumeration contient les exitCodes de la classe ExitStatus du framework Spring Batch
export enum JobStatus {
	// Ce status est souvent lie au demarrage d'un job, mais avant que la moindre Step
	// n'aie pu s'initialiser 
	UNKNOWN = "UNKNOWN",
	
	ONGOING = "EXECUTING",
	COMPLETED = "COMPLETED",
	FAILED = "FAILED",
}

export class JobProgressStatus {
	label!: string;
	processedCount!: number;
	totalCount!: number;
	status!: JobStatus;
	
	constructor() {
	}
}